import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find";
import _sortInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/sort";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React from 'react';
import classNames from 'classnames';
var gradientSeed = 0;
var Circle = function Circle(props) {
  var _context, _context2, _context3, _context4, _context5, _context6, _context7, _context8, _context9, _context10, _context11, _context12, _context13;
  var prefixCls = props.prefixCls,
    _props$percent = props.percent,
    percent = _props$percent === void 0 ? 0 : _props$percent,
    _props$width = props.width,
    width = _props$width === void 0 ? 88 : _props$width,
    _props$strokeWidth = props.strokeWidth,
    strokeWidth = _props$strokeWidth === void 0 ? 4 : _props$strokeWidth,
    trailColor = props.trailColor,
    strokeColor = props.strokeColor,
    children = props.children;
  var circleStyle = {
    width: "".concat(width, "px"),
    height: "".concat(width, "px")
  };
  var gradientId = gradientSeed;
  gradientSeed++;
  var radius = 50 - strokeWidth / 2;
  var beginPositionX = 0;
  var beginPositionY = -radius;
  var endPositionX = 0;
  var endPositionY = radius * 2;
  var len = Math.PI * 2 * radius;
  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
  var stripPercentToNumber = function stripPercentToNumber(percent) {
    return +percent.replace('%', '');
  };
  var toArray = function toArray(symArray) {
    return Array.isArray(symArray) ? symArray : [symArray];
  };
  var gradientColor = _findInstanceProperty(_context = toArray(strokeColor)).call(_context, function (color) {
    return Object.prototype.toString.call(color) === '[object Object]';
  });
  var gradientArr = isGradient ? _sortInstanceProperty(_context2 = _Object$keys(gradientColor)).call(_context2, function (a, b) {
    return stripPercentToNumber(a) - stripPercentToNumber(b);
  }) : null;
  var gradientDom = isGradient ? /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: _concatInstanceProperty(_context3 = "".concat(prefixCls, "-gradient-")).call(_context3, gradientId),
    x1: "100%",
    y1: "0%",
    x2: "0%",
    y2: "0%"
  }, gradientArr === null || gradientArr === void 0 ? void 0 : _mapInstanceProperty(gradientArr).call(gradientArr, function (key, index) {
    return /*#__PURE__*/React.createElement("stop", {
      key: index,
      offset: key,
      stopColor: gradientColor[key]
    });
  }))) : null;
  var pathColor = strokeColor && typeof strokeColor !== 'string' ? _concatInstanceProperty(_context4 = "url(#".concat(prefixCls, "-gradient-")).call(_context4, gradientId, ")") : strokeColor;
  var pathString = _concatInstanceProperty(_context5 = _concatInstanceProperty(_context6 = _concatInstanceProperty(_context7 = _concatInstanceProperty(_context8 = _concatInstanceProperty(_context9 = _concatInstanceProperty(_context10 = _concatInstanceProperty(_context11 = _concatInstanceProperty(_context12 = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, " \n\n                      a ")).call(_context12, radius, ",")).call(_context11, radius, " 0 1 1 ")).call(_context10, endPositionX, ",")).call(_context9, endPositionY, " \n\n                      a ")).call(_context8, radius, ",")).call(_context7, radius, " 0 1 1 ")).call(_context6, endPositionX, ",")).call(_context5, -endPositionY, " \n");
  var pathStyle = {
    strokeDasharray: _concatInstanceProperty(_context13 = "".concat(percent / 100 * len, "px ")).call(_context13, len, "px"),
    strokeDashoffset: '0px',
    opacity: percent === 0 ? 0 : 1,
    stroke: pathColor
  };
  var wrapperClassName = classNames("".concat(prefixCls, "-circle-box"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: wrapperClassName,
    style: circleStyle
  }, /*#__PURE__*/React.createElement("svg", {
    className: "".concat(prefixCls, "-circle"),
    viewBox: "0 0 100 100",
    strokeWidth: strokeWidth
  }, gradientDom, /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-circle-trail"),
    style: {
      stroke: trailColor
    },
    d: pathString,
    // stroke={trailColor}
    strokeWidth: strokeWidth,
    fillOpacity: "0",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    className: "".concat(prefixCls, "-circle-path"),
    d: pathString,
    // stroke={pathColor}
    strokeWidth: strokeWidth,
    style: pathStyle,
    fillOpacity: "0",
    strokeLinecap: "round"
  })), children));
};
export default Circle;